<template>
    <div>
        <b-modal v-model="show" title="会员充值" hide-footer no-close-on-backdrop class="pay_title">
            <div style="display:flex;">
                <div class="pay_div">
                    <div class="pay-username">
                        <div>账号:{{ getLoginCookieName() }}</div>
                    </div>
                    <!-- 账户金额详情 -->
                    <div>
                        <b-card style="border: none;">
                            <b-card-text class="custome-info-wrap">
                                <Tooltip content="账户金额包含了冻结金额" placement="right">
                                    <p>{{
                                        '账户金额:' + getNumberThousandString(getNumberFloorDecimal(memberFund), '0.00') + '元'
                                    }}</p>
                                </Tooltip>
                                <br>
                                <Tooltip content="会员定金单的定金金额汇总" placement="right">
                                    <p>{{
                                        '定金金额:' + getNumberThousandString(memberDepositBablance, '0.00') + '元'
                                    }}</p>
                                </Tooltip>
                                <br>
                                <Tooltip max-width="200"
                                         content="冻结金额=订单全额-定金，会员已生成发货单，苗场未点发货的金额汇总（不含定金）"
                                         placement="right">
                                    <p>{{ '冻结金额:' + getNumberThousandString(depositBablance, '0.00') + '元' }}</p>
                                </Tooltip>
                                <p>{{
                                    '可用余额:' + getNumberThousandString(getNumberFloorDecimal(numberSubtraction(memberFund, depositBablance), 2), '0.00') + '元'
                                }}</p>
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="custome_value">
                        <span>充值金额:</span>
                        <b-form-input v-model="orderAmount" placeholder="输入充值金额"
                                      style="width:160px;margin-left: 10px;border:none;font-size: 22px;color: red;">
                        </b-form-input>
                        <span style="font-size: 10px;">（* 最多保留小数点后两位数字）</span>
                    </div>
                    <div class="pay_type" v-if="isOpenPay">
                        <b-form-group label="" class="pay_type_group pay-type-group" v-if="payCode == 'ABC'">
                            <b-form-radio v-model="payType" name="some-radios" value="WeiXin" @change="hidePayResult"
                                          style="display: inline-block !important;">
                                <img src="../../assets/pay/pay_weixin.png" alt="微信支付">微信
                            </b-form-radio>
                            <b-form-radio v-model="payType" name="some-radios" value="AliPay" @change="hidePayResult"
                                          style="display: inline-block !important;">
                                <img src="../../assets/pay/pay_zhifubao.png" alt="支付宝支付">支付宝
                            </b-form-radio>
                        </b-form-group>
                        <!-- <b-form-group label="" class="pay_type_group pay-type-group" v-if="payCode == 'CMB'">
                            <div>
                                <img src="../../assets/pay/pay_CUP.png" height="40px" width="40px"
                                    alt="招行聚合支付">银联支付(微信、支付宝、银联)
                            </div>
                        </b-form-group>
                        <b-form-group label="" class="pay_type_group pay-type-group" v-if="payCode == 'CCBC'">
                            <div>
                                <img src="../../assets/pay/pay_CUP.png" height="40px" width="40px"
                                    alt="招行聚合支付">建行聚会支付(微信、支付宝、建行APP或云闪付)
                            </div>
                        </b-form-group> -->
                        <div v-for="option in payTypeOptions" :key="option.value" style="margin-top: 20px;">
                            <input type="radio" :value="option.value" v-model="payCode">
                            <img :src="option.srcUrl"><label
                            style="margin-left: 20px;color: red;">{{ option.tips }}</label>
                        </div>
                        <div class="pay_logo">
                            <!-- <img style="height:70px;"
                                src="../../assets/zhongmiao_logo.jpg"
                                alt=""> -->
                            <b-button style="width:450px;margin-top:25px;" variant="success" @click="submitPay()">
                                <b-spinner small v-if="showSpin"></b-spinner>
                                <span>立即充值</span>
                            </b-button>
                        </div>
                    </div>
                    <div class="pay_desc">
                        在线充值说明：<br/>
                        1、在线扫码充值，立即到会员账户。<br/>
                        2、农行、微信与支付宝扫码充值减免手续费，如国家政策调整，种苗网会提前通告收费标准。<br/>
                        3、如需线下汇款，请复制下方转账信息。此方法汇款后需人工录入，款到账较慢，慎用！<br/>
                        <!-- <b-button style="width:100px;margin-top:10px;" variant="info" @click="showTransformInfo = true">
                            <span>转账</span>
                        </b-button> -->
                    </div>
                    <div class="pay_result">
                        <div class="bank-transfer-header">
                            <i class="bank-icon"></i>
                            <h3>银行转账信息</h3>
                            <b-button variant="outline-success" size="sm" class="copy-all-btn"
                                      @click="copyAllBankInfo()">
                                复制转账信息
                            </b-button>
                        </div>
                        <div class="bank-info-container">
                            <div>
                                <span>收款账户：</span>
                                <span>广州缤纷园艺有限公司</span>
                            </div>
                            <div>
                                <span>银行账号：</span>
                                <span>44048701040002013</span>
                            </div>
                            <div>
                                <span>开户银行：</span>
                                <span>中国农业银行股份有限公司广州广中支行</span>
                            </div>
                        </div>
                        <div class="important-notice">
                            <i class="warning-icon">⚠️</i>
                            <strong>重要提醒：</strong>汇款时请务必备注您的会员账号
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="showPayResult" title="会员充值" hide-footer no-close-on-backdrop @close="onClose">
            <div>
                <div class="pay_result">
                    <div style="font-size:24px;color:red;text-align:center;">请您及时充值，以便尽快到帐订购！</div>
                    <div style="display:flex;margin-top:10px;">
                        <div style="line-height: 30px;">
                            <div>账号:{{ getLoginCookieName() }}</div>
                            <div>单号:{{ orderNo }}</div>
                            <div>金额:{{ orderAmount }}</div>
                            <div>状态:{{ payStatus }}</div>
                            <div>方式:{{ getPayType() }}</div>
                            <!--							<div><a v-if="payLink" style="color:red;" v-clipboard:copy="payLink"-->
                            <!--									v-clipboard:success="onCopy" v-clipboard:error="onError">点击复制支付链接</a></div>-->

                        </div>
                        <div v-if="showQrCode" style="margin-left:10px; text-align:center;">
                            <div id="qrcodeImg" style="codeimg"></div>
                            <div style="margin-top: 5px;">{{ getPayType() }}扫码支付</div>
                        </div>
                    </div>
                    <div v-if="showQueryButton" style="display: flex; margin-top:20px;">
                        <div style="font-size:12px; color:red;">支付完成前请不要关闭此支付验证窗口<br/>支付完成后，请根据您支付的情况点击右边按钮。
                        </div>
                        <b-button style="width:120px;margin-left:30px;" variant="warning" @click="queryPay()">
                            <b-spinner small v-if="showSpinQuery"></b-spinner>
                            <span>我已支付</span>
                        </b-button>
                    </div>

                </div>
            </div>
        </b-modal>
        <b-modal v-model="showTransformInfo" title="会员转账" hide-footer no-close-on-backdrop @close="onClose">

        </b-modal>
    </div>
</template>

<script>
import api from '@/api/api';
import { getNumberThousandString, getNumberFloorDecimal, numberSubtraction } from '@/libs/utils';
import HttpRequest from '@/libs/axios';
import QRCode from 'qrcodejs2';

export default {
    name: "PayModal",
    mounted() {
        if (this.checkMemberLogin()) {
            this.getPaymentChannel();
            this.getMemberDetailInfo();
            this.getpayConfigList();
            this.getCCBCMaxMoney();
        }
    },
    data() {
        return {
            userName: '',
            userPersonName: '',
            show: false,
            orderAmount: 0,
            payType: 'WeiXin',
            showSpin: false,
            showSpinQuery: false,
            orderNo: "",
            payStatus: "未支付",
            showPayResult: false,
            showQrCode: false,
            showTransformInfo: false,
            showQueryButton: true,
            payLink: '',
            paymentChannel: '1',
            memberFund: 0,
            depositBablance: 0,
            orderTotalMoney: 0,
            memberDepositBablance: 0,
            payMoney: 0,
            payConfigList: [],
            //selectedValue:'',
            payTypeOptions: [],
            isOpenPay: false,
            payCode: '',
            timer: null,
            timerCount: 0,
            cMBMaxMoney: 0
        };
    },
    methods: {
        getNumberThousandString,
        getNumberFloorDecimal,
        numberSubtraction,
        getMemberDetailInfo() {
            let data = {
                userUuid: this.getLoginCookieUuid()
            };
            api.getMemberDetailInfo(data).then(res => {
                if (res.code === 0) {
                    this.memberFund = res.data.memberFund;
                    this.depositBablance = res.data.depositBablance;
                    this.orderTotalMoney = res.data.orderTotalMoney;
                    this.memberDepositBablance = res.data.memberDepositBablance;
                    this.payMoney = res.data.orderTotalMoney;
                    //	this.setDefaultPayValue(res.data.orderTotalMoney);
                }
            });
        },
        getCCBCMaxMoney() {
            api.getCMBMaxMoney().then(res => {
                if (res.code == 0) {
                    this.cMBMaxMoney = res.data.maxMoney
                }
            })
        },
        getPaymentChannel() {
            api.getPaymentChannel().then(res => {
                if (res.code === 0) {
                    this.paymentChannel = res.data.paymentChannel;
                }
            });
        },
        getpayConfigList() {
            api.getPayPlatformConfigList().then(res => {
                if (res.code == 0) {
                    this.payConfigList = res.data.records.filter(x => x.isApp == 0 && x.platformConfigStatus == 1).sort((a, b) => (a.code === 'WeiXin' ? -1 : b.code === 'WeiXin' ? 1 : 0))
                    this.isOpenPay = this.payConfigList.length > 0 ? true : false;
                    if (this.isOpenPay) {
                        this.payCode = this.payConfigList[0].code;
                        this.payTypeOptions = this.payConfigList.filter(x => x.code != 'ABC').map(x => this.getPayOptins(x.code));
                        // console.log(this.payTypeOptions)
                        // console.log(this.payTypeOptions[0])
                    }

                }

            })
        },
        getPayOptins(code) {
            let srcUrl;
            let tips = '';
            if (code == 'CCBC') {
                srcUrl = require('../../assets/pay/ccb_union_pay.png');
                tips = '(支付有效时间是15分钟)';
            } else if (code == 'CMB') {
                srcUrl = require('../../assets/pay/cmb_union_pay-2.png');
                tips = '(支付有效时间是12小时)';
            } else if (code == 'WeiXin') {
                srcUrl = require('../../assets/pay/pay_weixin.png');
                tips = '(支付有效时间是2小时)';
            }
            return { srcUrl, value: code, tips }
        },

        //--复制功能开始--
        // 复制全部银行转账信息
        copyAllBankInfo() {
            const text = "收款账户: 广州缤纷园艺有限公司\n银行账号: 44048701040002013\n开户银行: 中国农业银行股份有限公司广州广中支行";
            this.execCopy(text);
        },

        /**
         * 兼容 HTTP 和 HTTPS 的强力复制函数
         * 核心修复：
         * 1. HTTPS 环境：优先使用 navigator.clipboard
         * 2. HTTP 环境：使用 execCommand，但通过 opacity:0 代替 left:-9999px，防止浏览器判定为“不可见元素”而拦截复制
         */
        async execCopy(text) {
            // 1. 优先尝试现代 API (仅在 HTTPS 且支持的环境下)
            if (navigator.clipboard && window.isSecureContext) {
                try {
                    await navigator.clipboard.writeText(text);
                    this.onCopy();
                    return; // 成功则直接结束
                } catch (err) {
                    console.warn("HTTPS 复制失败，降级到 execCommand:", err);
                }
            }

            // 2. 降级方案 (HTTP 或 API 失败时)
            try {
                const textArea = document.createElement("textarea");
                textArea.value = text;

                // --- 样式核心修改 ---
                // 不要把元素移出屏幕 (left: -9999px)，这会导致 HTTP 下复制失败
                // 而是把它放在屏幕内，用透明度隐藏
                textArea.style.position = "fixed";
                textArea.style.top = "50%";
                textArea.style.left = "50%";
                textArea.style.transform = "translate(-50%, -50%)"; // 居中
                textArea.style.width = "1px";
                textArea.style.height = "1px";
                textArea.style.padding = "0";
                textArea.style.border = "none";
                textArea.style.outline = "none";
                textArea.style.boxShadow = "none";
                textArea.style.background = "transparent";
                textArea.style.opacity = "0"; // 视觉隐藏
                textArea.style.zIndex = "-10"; // 置于底层

                // 防止 iOS 弹出键盘，但允许选区
                textArea.setAttribute("readonly", "readonly");

                document.body.appendChild(textArea);

                // 选中逻辑
                textArea.focus();
                textArea.select();

                // iOS 额外兼容
                textArea.setSelectionRange(0, textArea.value.length);

                // 执行复制
                const successful = document.execCommand("copy");

                // 清理元素
                document.body.removeChild(textArea);

                if (successful) {
                    this.onCopy();
                } else {
                    // 极少数情况仍然失败
                    console.warn("execCommand 复制返回 false");
                    this.onError();
                }
            } catch (err) {
                console.error("复制过程报错:", err);
                this.onError();
            }
        },

        onCopy() {
            this.$bvToast.toast("内容已复制到剪切板！", {
                title: '提示',
                variant: 'success',
                autoHideDelay: 2000,
                solid: true
            });
        },

        onError() {
            this.$bvModal.msgBoxOk("复制失败，请手动长按文本进行复制。", {
                title: '提示',
                buttonSize: 'sm',
                centered: true
            });
        },
        //--复制功能结束--

        // 检查用户交互状态（可选增强）
        isUserInteracting() {
            // 检查最近的用户交互（500ms内）
            return this.lastUserInteraction && (Date.now() - this.lastUserInteraction < 500);
        },
        onClose(e) {
            if (this.showPayResult && this.payStatus === '未支付') {
                e.preventDefault();
                this.$bvModal.msgBoxConfirm("充值未完成支付，是否确认离开该页面？", {
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "是",
                    cancelTitle: "否"
                }).then(value => {
                    if (value) {
                        this.hidePayResult();
                        this.showPayResult = false;
                    }
                });
            }
        },
        showModal() {
            this.show = true;
        },
        hidePayResult(e) {
            this.showPayResult = false;
            this.showQrCode = false;
        },
        getPayType() {
            if (this.payCode === "CMB") {
                return '支付宝、银联';
            } else if (this.payCode === "CCBC") {
                return '微信、支付宝、建行APP、云闪付';
            } else if (this.payType === "WeiXin" || this.payCode === "WeiXin") {
                return '微信';
            } else if (this.payType === "AliPay" || this.payCode === "AliPay") {
                return '支付宝';
            }
        },
        qrcode(url) {
            // 获取二维码节点
            let qrcodeNode = document.getElementById('qrcodeImg');

            // 清空节点内容
            qrcodeNode.textContent = '';
            new QRCode('qrcodeImg', {
                width: 180,
                height: 180,
                text: url, // 二维码地址
                colorDark: '#000',
                colorLight: '#fff'
            });
        },
        setDefaultPayValue(value) {
            this.orderAmount = value;
        },

        submitPay() {
            if (!this.validateAmount()) {
                return;
            }
            this.hidePayResult();
            let code = this.payCode;
            if (code == "CMB") {
                this.submitPay_CMB();
            } else if (code == "CCBC") {
                this.submitPay_CCBC();
            } else if (code == "WeiXin") {
                this.submitPay_self();
            } else if (this.paymentChannel === "1") {
                this.submitPay_nonghang();
            }
        },
        validateAmount() {
            let exp = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
            if (!exp.test(this.orderAmount) || this.orderAmount <= 0) {
                this.$bvModal.msgBoxOk("填写的充值金额格式不对！", {
                    title: '提示',
                    buttonSize: 'sm'
                });
                return false;
            }
            return true;
        },
        submitPay_CMB() {
            this.cMBMaxMoney == 0 ? 50000 : this.cMBMaxMoney;
            if (this.orderAmount > this.cMBMaxMoney) {
                this.$bvModal.msgBoxOk(`充值金额不能超过${this.cMBMaxMoney / 10000}万`, {
                    title: '提示',
                    buttonSize: 'sm'
                })
                return;
            }
            api.createCMBPay({
                orderAmount: this.orderAmount
            }).then(res => {
                if (res.code == 0) {
                    this.showSpin = false;
                    this.showPayResult = true;
                    this.showQrCode = true;
                    this.orderNo = res.data.orderNo;
                    this.payLink = res.data.qrUrl;
                    setTimeout(() => {
                        this.qrcode(res.data.qrUrl);
                        this.queryPay_CMB();
                    }, 300);
                } else {
                    this.$bvModal.msgBoxOk(res.message, {
                        title: '提示',
                        buttonSize: 'sm'
                    })
                }
            })

        },
        submitPay_CCBC() {
            if (this.orderAmount > 50000) {
                this.$bvModal.msgBoxOk('充值金额不能超过5万', {
                    title: '提示',
                    buttonSize: 'sm'
                })
                return;
            }
            api.createCCBCPay({
                orderAmount: this.orderAmount
            }).then(res => {
                if (res.code == 0) {
                    this.showSpin = false;
                    this.showPayResult = true;
                    this.showQrCode = true;
                    this.orderNo = res.data.orderNo;
                    this.payLink = res.data.qrUrl;
                    setTimeout(() => {
                        this.qrcode(res.data.qrUrl);
                        this.queryPay_CCBC();
                    }, 300);
                } else {
                    this.$bvModal.msgBoxOk(res.message, {
                        title: '提示',
                        buttonSize: 'sm'
                    })
                }
            })

        },
        submitPay_nonghang() {
            this.hidePayResult();
            if (this.payType === 'WeiXin' || this.payCode === 'WeiXin') {
                this.showSpin = true;
                api.createABCWeixin({
                    orderAmount: this.orderAmount
                }).then(res => {
                    this.showSpin = false;
                    this.showPayResult = true;
                    this.showQrCode = true;
                    this.orderNo = res.data.orderNo;
                    this.payLink = res.data.qrUrl;
                    setTimeout(() => {
                        this.qrcode(res.data.qrUrl);
                    }, 300);
                });
            } else if (this.payType === 'AliPay' || this.payCode === 'AliPay') {
                this.showSpin = true;
                api.createABCAliPay({
                    orderAmount: this.orderAmount
                }).then(res => {
                    this.showSpin = false;
                    this.showPayResult = true;
                    this.showQrCode = true;
                    this.orderNo = res.data.orderNo;
                    this.payLink = '';
                    setTimeout(() => {
                        this.qrcode(res.data.qrUrl);
                    }, 300);
                });
            }
        },
        submitPay_self() {
            this.hidePayResult();
            if (this.payType === 'WeiXin' || this.payCode === 'WeiXin') {
                this.showSpin = true;
                api.createWeiXinPay({
                    orderAmount: this.orderAmount
                }).then(res => {
                    this.showSpin = false;
                    this.showPayResult = true;
                    this.showQrCode = true;
                    this.payLink = res.data.payUrl;
                    this.orderNo = res.data.orderNo;
                    setTimeout(() => {
                        this.qrcode(res.data.payUrl);
                        this.queryPay_wx();
                    }, 300);
                });
            } else if (this.payType === 'AliPay' || this.payCode === 'AliPay') {
                this.showSpin = true;
                api.createAliPay({
                    orderAmount: this.orderAmount
                }).then(res => {
                    this.showSpin = false;
                    this.showPayResult = true;
                    this.orderNo = res.data.orderNo;
                    window.open(res.data.aliPayUrl, "_blank");
                });
            }
        },
        queryPay() {
            if (this.payCode == "CMB") {
                //	this.queryPay_CMB();
            } else if (this.payCode == "WeiXin") {
                this.queryPay_self();
            } else if (this.paymentChannel === "1") {
                this.queryPay_nonghang();
            }
        },
        queryPay_CMB() {
            this.showQueryButton = false;
            clearInterval(this.timer);   //清除定时器
            this.timer = setInterval(() => {
                console.log(this.timerCount);
                if (!this.showPayResult) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                }
                api.QueryCMBPay({
                    orderNo: this.orderNo,
                    orderAmount: this.orderAmount
                }).then(res => {
                    if (res.data.code === 0) {
                        clearInterval(this.timer);   //清除定时器
                        this.timer = null;
                        this.timerCount = 0;
                        this.payStatus = '已支付';
                        //	this.$Message.info('支付成功');
                        this.showPayResult = false;
                        //    window.location.reload();

                        this.$bvModal.msgBoxOk("支付成功", {
                            title: '提示',
                            buttonSize: 'sm'
                        }).then(value => {
                            window.parent.window.location.reload();
                        });

                    } else if (res.data.code != 4) {

                        this.$bvModal.msgBoxOk(res.message, {
                            title: '提示',
                            buttonSize: 'sm'
                        });
                        clearInterval(this.timer);   //清除定时器
                        this.timer = null;
                        this.timerCount = 0;
                        this.showPayResult = false;
                    }
                })

                if (this.timerCount > 90) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                    this.showPayResult = false;
                } else {
                    this.timerCount++;
                }
            }, 10000);

        },
        queryPay_CCBC() {
            this.showQueryButton = false;
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                console.log(this.timerCount);
                if (!this.showPayResult) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                }
                api.QueryCCBCPay({
                    orderNo: this.orderNo,
                    orderAmount: this.orderAmount
                }).then(res => {
                    if (res.data.code === 0) {
                        clearInterval(this.timer);   //清除定时器
                        this.timer = null;
                        this.timerCount = 0;
                        this.payStatus = '已支付';
                        //	this.$Message.info('支付成功');
                        this.showPayResult = false;
                        //    window.location.reload();

                        this.$bvModal.msgBoxOk("支付成功", {
                            title: '提示',
                            buttonSize: 'sm'
                        }).then(value => {
                            window.parent.window.location.reload();
                        });

                    } else if (res.data.code != 4) {

                        this.$bvModal.msgBoxOk(res.message, {
                            title: '提示',
                            buttonSize: 'sm'
                        });
                        clearInterval(this.timer);   //清除定时器
                        this.timer = null;
                        this.timerCount = 0;
                        this.showPayResult = false;
                    }
                })

                if (this.timerCount > 90) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                    this.showPayResult = false;
                } else {
                    this.timerCount++;
                }
            }, 10000);

        },
        queryPay_nonghang() {
            this.showSpinQuery = true;
            api.QueryABCPay({
                orderNo: this.orderNo
            }).then(res => {
                this.showSpinQuery = false;
                if (res.code === 0) {
                    // console.log(res);
                    if (res.data.result.status === '03' || res.data.result.status === '04') {
                        this.payStatus = '已支付';
                        this.$bvModal.msgBoxOk("支付成功", {
                            title: '提示',
                            buttonSize: 'sm'
                        }).then(value => {
                            window.parent.window.location.reload();
                        });
                        this.showQueryButton = false;
                    } else {
                        this.$bvModal.msgBoxOk("未完成支付", {
                            title: '提示',
                            buttonSize: 'sm'
                        });
                    }
                }
            });
        },

        queryPay_self() {
            if (this.payType === 'WeiXin' || this.payCode === 'WeiXin') {
                this.showSpinQuery = true;
                api.queryWeiXinPay({
                    tradeNo: this.orderNo
                }).then(res => {
                    this.showSpinQuery = false;
                    if (res.code === 0) {
                        console.log(res);
                        if (res.data.dictResult.trade_state === 'SUCCESS') {
                            this.payStatus = '已支付';
                            this.$bvModal.msgBoxOk("支付成功", {
                                title: '提示',
                                buttonSize: 'sm'
                            }).then(value => {
                                window.parent.window.location.reload();
                            });
                            this.showQueryButton = false;
                        } else {
                            this.$bvModal.msgBoxOk("未完成支付:" + res.data.dictResult.trade_state_desc, {
                                title: '提示',
                                buttonSize: 'sm'
                            });
                        }
                    }
                });
            } else if (this.payType === 'AliPay' || this.payCode === 'AliPay') {
                this.showSpinQuery = true;
                api.queryAliPay({
                    tradeNo: this.orderNo
                }).then(res => {
                    this.showSpinQuery = false;
                    if (res.code === 0) {
                        console.log(res);
                        if (res.data.payStatus === 'TRADE_SUCCESS' || res.data.payStatus ===
                            'TRADE_FINISHED') {
                            this.payStatus = '已支付';
                            this.$bvModal.msgBoxOk("支付成功", {
                                title: '提示',
                                buttonSize: 'sm'
                            }).then(value => {
                                window.parent.window.location.reload();
                            });
                            this.showQueryButton = false;
                        } else {
                            this.$bvModal.msgBoxOk("未完成支付:" + res.data.response.sub_msg, {
                                title: '提示',
                                buttonSize: 'sm'
                            });
                        }
                    }
                });
            }
        },
        queryPay_wx() {
            this.showQueryButton = false;
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                console.log(this.timerCount);
                if (!this.showPayResult) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                }
                api.queryWeiXinPay({
                    tradeNo: this.orderNo
                }).then(res => {
                    this.showSpinQuery = false;
                    if (res.code === 0) {
                        console.log(res);
                        if (res.data.dictResult.trade_state === 'SUCCESS') {
                            clearInterval(this.timer);   //清除定时器
                            this.timer = null;
                            this.timerCount = 0;
                            this.payStatus = '已支付';
                            this.showPayResult = false;
                            this.$bvModal.msgBoxOk("支付成功", {
                                title: '提示',
                                buttonSize: 'sm'
                            }).then(value => {
                                window.parent.window.location.reload();
                            });
                            this.showQueryButton = false;
                        }
                    }
                });

                if (this.timerCount > 90) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                    this.showPayResult = false;
                } else {
                    this.timerCount++;
                }
            }, 6000);

        }

    }
};
</script>

<style>
.pay_desc {
    margin-top: 20px;
    color: #fc3023;
    font-size: 15px;
}

.pay_logo {
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* 在线充值账户名 */
.pay-username {
    position: relative;
    right: 165px;
    font-size: 22px;
    color: #1da25a;
}

/* 账户金额信息 */
.custome-info-wrap {
    padding: 22px;
    background-color: #ecf5ff;
    border: 1px solid #2979ff;
    border-radius: 10rpx;
    width: 460px;
    border-radius: 5px;
}

.pay_type {
    width: 450px;
    /* height: 160px; */
    padding-left: 20px;
    padding-right: 20px;
    /* 	display: flex;
    justify-content: space-between;
    align-items: center; */
    border-bottom: 1px solid lightgrey;
}

.pay_type_radio {
    margin-top: 20px !important;

}

.pay_type_radio img {
    height: 30px;
    margin-left: 10px;
}

.pay_type_group b-form-radio {
    display: inline-block !important;
}


/* .pay_type b-form-group{display: inline-block;} */
.pay_type_group .pay-type-group {
    display: inline-block;
}

.pay_type_radio .custom-control .custom-radio {
    display: inline-block !important;
}

.custome_value {
    width: 450px;
    display: flex;
    /* justify-content: center;	 */
    padding-left: 18px;
    align-items: center;
    margin-top: 20px;
    border-bottom: 1px solid lightgrey;
    margin-bottom: 30px;
    /* padding-bottom: 10px; */
}

.custome_value span {
    font-size: 20px;
    color: burlywood;
}

.default_value_button {
    width: 450px;
    display: flex;
    justify-content: space-around;
}

.default_value_button button {
    width: 80px;
    color: #969696;
    background-color: transparent;
    border: 1px solid #969696;
}

.pay_div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    width: 460px;
    /* border: solid 1px lightgrey; */
}

.pay_result {
    padding: 10px;
    border: solid 1px lightgrey;
}

/*会员充值抬头修改样式*/
.modal-header {
    background-color: #1da25a;
    color: #fff;
}

.close {
    color: #FFF
}

.close:hover {
    color: #FFF
}

/*会员充值金额文字修改样式*/
.custome_value span {
    color: #af8609
}

/*会员充值支付方式修改样式*/
.custom-control-label img {
    margin-right: 10px;
}

/* 银行转账信息样式优化 */
.pay_result {
    padding: 20px;
    border: 2px solid #e3f2fd;
    border-radius: 12px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
    margin-top: 20px;
}

.bank-transfer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #1da25a;
}

.bank-icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: linear-gradient(135deg, #1da25a 0%, #4caf50 100%);
    border-radius: 50%;
    margin-right: 12px;
    position: relative;
}

.bank-icon::before {
    content: '🏦';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
}

.bank-transfer-header h3 {
    margin: 0;
    color: #1da25a;
    font-size: 20px;
    font-weight: 600;
}

.bank-info-container {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.bank-info-item {
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
}

.bank-info-item:last-child {
    border-bottom: none;
}

.info-label {
    font-weight: 600;
    color: #333;
    min-width: 80px;
    font-size: 14px;
}

.info-value {
    flex: 1;
    color: #555;
    font-size: 15px;
    font-family: 'Courier New', monospace;
}

.account-number {
    font-weight: 700;
    color: #1da25a;
    letter-spacing: 1px;
    background: #f0f9ff;
    padding: 4px 8px;
    border-radius: 4px;
    border: 1px solid #1da25a;
}

.copy-btn {
    margin-left: 12px;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.copy-btn:hover {
    background-color: #1da25a;
    border-color: #1da25a;
    transform: translateY(-1px);
}

.copy-all-btn {
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 4px;
    transition: all 0.3s ease;
    font-weight: 500;
}

.copy-all-btn:hover {
    background-color: #1da25a;
    border-color: #1da25a;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(29, 162, 90, 0.3);
}

.important-notice {
    background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
    border: 2px solid #ffc107;
    border-radius: 8px;
    padding: 15px;
    color: #856404;
    font-weight: 500;
    display: flex;
    align-items: center;
    animation: pulse 2s infinite;
}

.warning-icon {
    margin-right: 10px;
    font-size: 16px;
    animation: shake 2s infinite;
}

.important-notice strong {
    color: #d63384;
    font-weight: 700;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
    }

    70% {
        box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    }
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-2px);
    }

    75% {
        transform: translateX(2px);
    }
}
</style>



// WEBPACK FOOTER //
// src/view/member/pay.vue